import { PageContent } from "../content";

export function Footer({ copy }: { copy: PageContent }) {
  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <strong>
          peyotl<span className="brand-domain">.mx</span>
        </strong>
        <p>
          {copy.footerTagline.map((line, index) => (
            <span key={line}>
              {line}
              {index < copy.footerTagline.length - 1 && <br />}
            </span>
          ))}
        </p>
      </div>
      <div className="footer-note">
        <p>
          {copy.footerNote.map((line, index) => (
            <span key={line}>
              {line}
              {index < copy.footerNote.length - 1 && <br />}
            </span>
          ))}
        </p>
      </div>
    </footer>
  );
}
